// extracted by mini-css-extract-plugin
export default {"tab":"SegmentedTabs_tab__feHc4"};